import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

//
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';     
import { IoMdAdd } from "react-icons/io";
import { IoPersonAddOutline } from "react-icons/io5";
//page links  
import { MdSettings } from 'react-icons/md'; 
import { MdDomainAdd} from "react-icons/md"; 
import { BsPersonWorkspace } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import { GoProjectSymlink } from "react-icons/go";
export default function Companys() {
  const location = useLocation();
  const navigate = useNavigate();
    const [user, setUser] = useState(null); 
    const [guid, setGuid] = useState("");
      const [CompanysUi, setCompanysUi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [islogoutLoading, setislogoutLoading] = useState(false);
      useEffect(() => {
        const existingUser = Cookies.get("guid");      
        if (existingUser != null) {
          setGuid(existingUser); // Still sets it in state if you need it elsewhere
    
        } else {
   
          navigate('/');
        }
      }, []);

        //companys-ui-grid
        useEffect(() => {
          if (guid) {
            const fetchcompanys = async () => {
              try {
                const q = query(
                  collection(db, "companys"),
                  where("guid", "==", guid)
                );
                const companysSnapshot = await getDocs(q);
                const companysList = companysSnapshot.docs.map(doc => ({
                  id: doc.id,
                  ...doc.data()
                }));
      
                setCompanysUi(companysList);
                setIsLoading(false);
              } catch (error) {
                console.error("Error fetching companys:", error);
                setIsLoading(false);
              }
            };
      
            fetchcompanys();
          }
        }, [guid]);
  return (
       <div > 
            
    <div > 
<div className="container_size">

  <br />
  <div className='comp-hd'> 
        <div className='contact-title-div'>
                <div className='contact-title'>Manage Companies</div>
                {/* <div className='contact-details'>Showcase your company on our platform</div> */}
              </div>
    <div className='com-btn' onClick={() => navigate(`/create-company-profile`)} >
      <div className='button-ui' ><MdDomainAdd className='icon' />Create</div>
    </div>
  </div>
  <br/>
  <div className="companys-ui-grid">
    {isLoading ? (
      <Lodinging />
    ) : (
      (() => {
      
        return CompanysUi.map((companyuilist, index) => {
          return (

            <div
              className="companys-ui-items"
       
              style={{ cursor: 'pointer' }}
            >
              <img
                className="company-logo"
                src={companyuilist.icon}
                alt="Logo"
                onLoad={() => setLoading(false)}
                onError={() => setLoading(false)} // also hides loader if there's an error
                style={{ display: loading ? 'none' : 'block' }} // hide img while loading
              />
              <div className='items-box'>
                <div className="items-name">{companyuilist.companyname}</div>
                <div className="items-hiring"><FaStar className='items-rating' />{companyuilist.rating + "  |  " + companyuilist.reviws + " reviews"}</div>
              </div>

              {companyuilist.industry && (
                <div className="home-industry-grid">
                  {companyuilist.industry.split(',').map((item, index) => (
                    <div key={index} className="items-industry">
                      {item.trim()}
                    </div>
                  ))}
                </div>
              )}
              <table className='links-table'>
                <tr  onClick={() => navigate(`/job-applied?uid=${companyuilist.uid}`)}>
                  <td >
                    <IoPersonAddOutline className='link_icon' />
                  </td>
                  <td >
                    <div className='links_text'>Job Applied</div>
                  </td>
                  <td>0</td>
                </tr>
                   <tr  onClick={() => navigate(`/job-list?uid=${companyuilist.uid}`)}>
                  <td >
                    <BsPersonWorkspace className='link_icon' />
                  </td>
                  <td >
                    <div className='links_text'>jobs List</div>
                  </td>
                  <td>0</td>
                </tr>
                     <tr  onClick={() => navigate(`/projact-list?uid=${companyuilist.uid}`)}>
                  <td >
                    <GoProjectSymlink className='link_icon' />
                  </td>
                  <td >
                    <div className='links_text'>Projact list</div>
                  </td>
                  <td>0</td>
                </tr>
                  <tr  onClick={() => navigate(`/create-job?uid=${companyuilist.uid}`)}>
                  <td >
                    <IoMdAdd className='link_icon' />
                  </td>
                  <td >
                    <div className='links_text'>Create new job</div>
                  </td>
                  <td>0</td>
                </tr>
              </table>
              <br/>
              <div className='center-container' onClick={() => navigate(`/company-management?uid=${companyuilist.uid}`)}>
                <div className='button-ui2'><MdSettings className='icon' />Management</div>
              </div>
            </div>

          );
        });
      })()
    )}
  </div>
</div>
</div>
</div> 
    );
}
